<template>
  <div class="mt-4">
    <v-toolbar>
      <v-toolbar-title>
        {{ $t('message.home.recentlyJobs') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ma-2" @click="get_data(get_prefix() + 'job', get_id())">
            mdi-refresh
          </v-icon>
        </template>
        <span>{{ $t("message.common.refresh") }}</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="data"
      :sort-by="['start_time']"
      :sort-desc="[true]"
      must-sort
      :items-per-page="5"
      hide-default-footer
      class="elevation-1 mt-1"
      @click:row="$router.push('/' + get_prefix() + 'job/' + $event.jid + '?referer=/');"
    >
      <template v-slot:item.jid="{ item }">
        {{ item.jid }}
      </template>
      <template v-slot:item.title="{ item }">
        <template v-if="item.title.length <= 40">
          {{ item.title }}
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.title.substr(0, 40) }}...
              </span>
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:item.type="{ item }">
        {{ $t('message.job.job_type_' + item.type) }}
      </template>
      <template v-slot:item.status="{ item }">
        <span :class="status_color[item.status]">{{ $t('message.job.status_' + item.status) }}</span>
      </template>
      <!--<template v-slot:item.progress="{ item }">
        <template v-if="['processing', 'complete'].indexOf(item.status) >= 0">
          {{ Math.round(10 * item.progress) / 10 }}%
          <v-progress-linear
            :value="item.progress"
          ></v-progress-linear>
        </template>
        <template v-else>
          -
        </template>
      </template>
      <template v-slot:item.wait_time="{ item }">
        <template v-if="item.status === 'processing'">
          {{ show_second(item.wait_time) }}
        </template>
        <template v-else>
          -
        </template>
      </template>-->
      <template v-slot:item.start_time="{ item }">
        {{ $d(1000 * item.start_time, 'long', $store.getters.langs[$i18n.locale].locale) }}
      </template>
      <template v-slot:item.operation="{ item }">
        <template v-if="item.status === 'finished'
          && item.output !== null
          && item.output.length > 0">
          <v-menu
            offset-x
            left
            min-width="600px"
            max-width="600px"
          >
            <template v-slot:activator="{ on: onMenu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: onTooltip }">
                  <v-icon
                    class="ma-2"
                    v-on="{ ...onMenu, ...onTooltip }"
                    @click.stop
                  >
                    mdi-file-check
                  </v-icon>
                </template>
                <span>{{ $t("message.job.check_result") }}</span>
              </v-tooltip>
            </template>

            <v-list class="pa-3">
              <template v-for="output in item.output">
                <IdName
                  :mode="mode"
                  :type="output.type"
                  :ids="[output.id[0]]"
                  :nav_path="nav_path"
                  :remarks="['estimate', 'similarity'].indexOf(item.type) >= 0 ? [item.type] : null"
                ></IdName>
              </template>
            </v-list>
          </v-menu>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Confirm from '../components/Confirm';
import IdName from '../components/IdName';
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";

export default {
  name: 'RecentlyJob',
  components: {
    Confirm,
    IdName
  },
  mixins: [res_list, http_error],
  data: function(){
    return {
      module_id: "58",
      nav_path: "/",
      data: [],
      target: {
        layer: "",
        gid: "",
        uid: ""
      },
      progress: 0,
      progress_overlay: false,
      search_jid: "",
      search_job: "",
      job_type: "all",
      job_types: [
        {
          "label": "all",
          "value": "all"
        },
        {
          "label": "translate",
          "value": "translate"
        },
        {
          "label": "estimate",
          "value": "estimate"
        },
        {
          "label": "train",
          "value": "train"
        },
        {
          "label": "corpus_import",
          "value": "corpus_import"
        },
        {
          "label": "similarity",
          "value": "similarity"
        }
      ],
      status_color: {
        "pending": "",
        "finished": "lime--text",
        "processing": "",
        "failed": "red--text",
        "cancelled": "grey--text"
      },
      mode: 'user'
    }
  },
  computed: {
    headers: function() {
      return [
        {
          text: this.$i18n.t("message.common.jid"),
          value: 'jid',
          filter: value => {
            if(this.search_jid === "" || this.search_jid === null){
              return true;
            }
            return value.indexOf(this.search_jid) !== -1;
          },
          sortable: false
        },
        {
          text: this.$i18n.t("message.common.title"),
          value: 'title',
          filter: value => {
            if(this.search_job === "" || this.search_job === null){
              return true;
            }
            return value.indexOf(this.search_job) !== -1;
          },
          sortable: false
        },
        {
          text: this.$i18n.t("message.common.type"),
          value: 'type',
          filter: value => {
            if(this.job_type === "all"){
              if(value === "modify"){
                return false;
              }
              return true;
            }
            return this.job_type === value;
          },
          sortable: false
        },
        {
          text: this.$i18n.t("message.common.status"),
          value: 'status',
          sortable: false
        },
        /*{ text: this.$i18n.t("message.common.progress") + "(%)", value: 'progress' },
        { text: this.$i18n.t("message.job.wait_time"), value: 'wait_time' },*/
        {
          text: this.$i18n.t("message.job.start_time"),
          value: 'start_time',
          sortable: false
        },
        {
          text: this.$i18n.t("message.job.check_result"),
          value: 'operation',
          sortable: false
        }
      ];
    },
  },
  mounted(){
    const get_prefix = this.mode === "user" ? "" : this.mode + "/";
    this.get_data(get_prefix + 'job' , this.get_id())
  },
  methods: {
    show_second: function(second){
      var hour = Math.floor(second / 3600);
      var minute = Math.floor((second % 3600) / 60);
      if(hour > 0){
        return hour + ":" + ('0' + minute).slice(-2) + ":" + ('0' + (second % 60)).slice(-2);
      }
      return ('0' + minute).slice(-2) + ":" + ('0' + (second % 60)).slice(-2)
    }
  }
}
</script>
